export enum CustomCommands {
  CURLY_QUOTES = 'mceCurlyQuotes',
}
